import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authorization-gate/orgs/$orgName/projects/$projectId/')({
	beforeLoad: ({ params }) => {
		throw redirect({ to: '/orgs/$orgName/projects/$projectId/overview', params });
	},
});
